const security = {
  OWNERKEY: "7cPfr97ZRE",
  STAFFKEY: "D5pY<0K2nBv>",
  ALLACCESS: "mJvR1_06+2^-",
  NOALLACCESS: "61YyA~P<0-ro",
};
export default security;
